const suppressedStrings = [
  "audience chattering",
  "audience laughs",
  "audience member mumbles",
  "audience member laughs",
  "beep",
  "beeping",
  "bell",
  "buzzer",
  "blank_audio",
  "chuckles",
  "clap",
  "clicking",
  "click",
  "clicks",
  "clears throat",
  "clippers buzzing",
  "cough",
  "coughing",
  "coughs",
  "crickets chirping",
  "crying",
  "door closes",
  "door closing",
  "door opening",
  "door opens",
  "dramatic music",
  "drum beats",
  "drum roll",
  "faintly speaking",
  "farting",
  "inaudible",
  "indistinct",
  "keyboard clicking",
  "laughs",
  "laughing",
  "loud thud",
  "mouse clicking",
  "mouseclicking",
  "muffled speaking",
  "murmuring",
  "music",
  "music playing",
  "pause",
  "phone ringing",
  "SCOFFS",
  "sighs",
  "sneezes",
  "sniffles",
  "sniff",
  "sn",
  "speaking in foreign language",
  "sad music",
  "silence",
  "sound",
  "squeaking",
  "swooshing",
  "typing",
  "upbeat music",
  "whistling",
  "whistles",
  "wind blowing",
  "whooshing",
];

export const isSuppressedString = (input: string): boolean => {
  const trimmedInput = input.trim().toLowerCase();
  const regex = new RegExp(
    suppressedStrings
      .map(
        (str) =>
          `\\*\\*${str}\\*\\*|\\[${str}\\]|\\(${str}\\)| ${str} |^${str}$`
      )
      .join("|"),
    "i"
  );

  return regex.test(trimmedInput);
};

export const dictationKeys = ["note", "macro", "diagnosis", "microscopic"];

export const findDictationKey = (input: string): string | undefined => {
  const trimmedInput = input.trim().toLowerCase();
  return dictationKeys.find((key) => trimmedInput.includes(key));
};
